import { createSelector } from 'reselect';
import { createDate, format } from '@lingoda/dates';
import { getTimeFormat } from '../utils';
import { studentPreferencesSelector } from './studentPreferences';

export const studentTimeSelector = createSelector(studentPreferencesSelector, (preferences) =>
    format(getTimeFormat(preferences?.timeFormat), createDate()),
);
